var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon, _path13, _polygon2, _path14, _path15, _circle, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotesHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 737.38976,
    height: 544,
    viewBox: "0 0 737.38976 544",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.621,513.18165,351.97511,545.35672a17.01916,17.01916,0,0,1-20.14075-13.12822L305.64055,407.95909a17.01916,17.01916,0,0,1,13.12823-20.14074l152.64588-32.17507A17.01915,17.01915,0,0,1,491.5554,368.7715l26.19381,124.26941A17.01916,17.01916,0,0,1,504.621,513.18165Zm-185.4397-123.4063a15.017,15.017,0,0,0-11.58373,17.77124L333.79136,531.816a15.017,15.017,0,0,0,17.77124,11.58373l152.64588-32.17508a15.017,15.017,0,0,0,11.58374-17.77124L489.59841,369.184a15.017,15.017,0,0,0-17.77125-11.58373Z",
    transform: "translate(-231.30512 -178)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ea648e8d-1b31-4ae2-9566-f54bfd0d94c9-182",
    "data-name": "Path 411",
    d: "M461.93038,396.61842,384.892,412.85676a2.73089,2.73089,0,0,1-3.22932-1.86307,2.63064,2.63064,0,0,1,1.99859-3.25411L462.08161,391.21c3.06195,1.72557,2.09419,4.93517-.15219,5.40867Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "b4f9d9e0-1a47-44a2-8a19-0d88a6e9c18f-183",
    "data-name": "Path 412",
    d: "M464.77869,410.13147l-77.03838,16.23835a2.73089,2.73089,0,0,1-3.22931-1.86308,2.63063,2.63063,0,0,1,1.99859-3.2541L464.92993,404.723c3.06195,1.72558,2.09418,4.93518-.1522,5.40867Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "e168965a-63e1-4676-8cbb-3e09d33a4a3f-184",
    "data-name": "Path 413",
    d: "M372.70815,437.57411l-23.51136,4.95578a2.962,2.962,0,0,1-3.50569-2.28509l-5.84823-27.74533a2.962,2.962,0,0,1,2.28509-3.50569l23.51137-4.95578a2.963,2.963,0,0,1,3.50569,2.28509l5.84823,27.74536a2.962,2.962,0,0,1-2.28509,3.50569Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "af0ff97e-1a3a-4f6f-a511-2c807a938985-185",
    "data-name": "Path 414",
    d: "M470.38655,437.84676,352.81186,462.62944a2.73086,2.73086,0,0,1-3.22929-1.86306,2.63063,2.63063,0,0,1,1.99859-3.25412l118.95758-25.07417c3.06195,1.72557,2.09419,4.93517-.15219,5.40867Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "e60f2d91-ad3b-421b-94cb-3aa0f5092f21-186",
    "data-name": "Path 415",
    d: "M473.2357,451.36376,355.661,476.14645a2.73087,2.73087,0,0,1-3.22929-1.86306,2.63063,2.63063,0,0,1,1.99858-3.25412l118.95759-25.07418c3.06195,1.72558,2.09418,4.93518-.15219,5.40867Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "a5554f8b-57e8-4c3b-815c-c76cc46b61b5-187",
    "data-name": "Path 416",
    d: "M476.083,464.87193,358.50829,489.65462a2.73088,2.73088,0,0,1-3.22929-1.86307,2.63062,2.63062,0,0,1,1.99859-3.25411l118.95759-25.07418c3.06195,1.72558,2.09418,4.93517-.1522,5.40867Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "eee68bf7-fbe9-4bfc-85ae-b0141fb14f45-188",
    "data-name": "Path 417",
    d: "M478.93192,478.38793,361.35723,503.17062a2.73087,2.73087,0,0,1-3.22929-1.86307,2.63061,2.63061,0,0,1,1.99858-3.25411l118.95759-25.07418c3.06195,1.72558,2.09418,4.93517-.15219,5.40867Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "b9a7afa1-162f-46e2-88e2-f572ab59fc71-189",
    "data-name": "Path 418",
    d: "M481.77942,491.89711,364.20473,516.6798a2.73087,2.73087,0,0,1-3.22929-1.86307,2.6306,2.6306,0,0,1,1.99858-3.25411l118.95759-25.07418c3.062,1.72558,2.09418,4.93518-.15219,5.40867Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M500.534,430.03021a10.52747,10.52747,0,0,0-.68327,1.51012l-48.13337,11.94434-8.37345-8.66256-14.725,10.92831,13.33321,16.77594a8,8,0,0,0,9.289,2.428l52.22933-21.34222a10.49709,10.49709,0,1,0-2.93641-13.5819Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M336.23731,536.32254a10.7427,10.7427,0,0,0,6.37825-15.18767l33.12422-92.06728-23.00366-4.07668-25.32663,91.781a10.8009,10.8009,0,0,0,8.82782,19.55061Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M371.533,445.41054l-22.71252-8.71684a4.81687,4.81687,0,0,1-2.46974-6.863l11.915-21.1257a13.37737,13.37737,0,0,1,24.95,9.65954l-5.25553,23.59756a4.81687,4.81687,0,0,1-6.42721,3.44849Z",
    transform: "translate(-231.30512 -178)",
    fill: "#102b3f"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "191.493 531.175 203.752 531.175 209.585 483.887 191.491 483.888 191.493 531.175",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M419.67063,705.17279l24.1438-.001h.001A15.38605,15.38605,0,0,1,459.20188,720.558v.5l-39.53051.00146Z",
    transform: "translate(-231.30512 -178)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.493 531.175 134.752 531.175 140.585 483.887 122.491 483.888 122.493 531.175",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M350.67063,705.17279l24.1438-.001h.001A15.38605,15.38605,0,0,1,390.20188,720.558v.5l-39.53051.00146Z",
    transform: "translate(-231.30512 -178)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M366.6504,690.14248H351.13575a4.50042,4.50042,0,0,1-4.49487-4.71387l7.36938-158.332.46436-.0127,74.91919-1.95312,14.6604,158.42285a4.50022,4.50022,0,0,1-4.12085,4.91113l-17.42627,1.39356a4.50225,4.50225,0,0,1-4.76709-3.582L395.44972,573.4999a1.45375,1.45375,0,0,0-1.469-1.19922h-.0061a1.45449,1.45449,0,0,0-1.46631,1.21094l-21.44263,113A4.50951,4.50951,0,0,1,366.6504,690.14248Z",
    transform: "translate(-231.30512 -178)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 163.765,
    cy: 183.32358,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M386.83448,545.65127c-11.7063,0-23.73022-3.07715-33.698-12.17481a4.55187,4.55187,0,0,1-1.46949-3.84961c1.0669-9.58594,6.24219-59.081,3.32764-92.14355a40.01955,40.01955,0,0,1,12.95557-33.30469,39.59814,39.59814,0,0,1,33.96215-9.834h.00025c.30591.05468.61157.1123.91772.17089,19.66358,3.80567,33.32593,22.00391,31.78,42.33106-2.25586,29.66016-4.27807,69.7793-1.10278,92.46777a4.49262,4.49262,0,0,1-2.4148,4.63672C423.86793,537.60146,405.76661,545.65127,386.83448,545.65127Z",
    transform: "translate(-231.30512 -178)",
    fill: "#102b3f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M418.88372,447.17782a4.81168,4.81168,0,0,1-2.10947-3.41136l-2.99231-23.98982a13.37737,13.37737,0,0,1,25.75414-7.24809l9.85629,22.16112a4.81688,4.81688,0,0,1-3.10993,6.59769l-23.43727,6.522A4.81146,4.81146,0,0,1,418.88372,447.17782Z",
    transform: "translate(-231.30512 -178)",
    fill: "#102b3f"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M386.496,385.53781a17.59793,17.59793,0,0,1-6.79721-1.2298c-.95139-.36664-1.939-.668-2.88862-1.03489-8.38662-3.24017-13.91121-12.17188-14.10907-21.16048s4.457-17.71287,11.36912-23.46238,15.865-8.70134,24.82986-9.38394c9.65661-.73527,20.53026,1.7136,25.92627,9.7556,1.43633,2.14065,2.44084,4.73783,1.58976,7.32246a4.68564,4.68564,0,0,1-1.32028,2.028c-2.40979,2.144-4.81223.53191-7.2688.38948-3.37653-.19576-6.40925,2.53734-7.49925,5.73908s-.61019,6.7266.26991,9.99228a24.96206,24.96206,0,0,1,1.25825,6.07589,6.1083,6.1083,0,0,1-2.53094,5.37854c-2.10991,1.27536-4.88078.53724-6.99193-.73607s-3.93535-3.04373-6.21577-3.98072-5.3442-.72915-6.6715,1.34848a7.379,7.379,0,0,0-.84344,2.43522c-1.18992,5.42125-.91644,5.102-2.10636,10.52322Z",
    transform: "translate(-231.30512 -178)",
    fill: "#2f2e41"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M726.69488,352h-156a17.01917,17.01917,0,0,1-17-17V208a17.01917,17.01917,0,0,1,17-17h156a17.01917,17.01917,0,0,1,17,17V335A17.01917,17.01917,0,0,1,726.69488,352Zm-156-159a15.017,15.017,0,0,0-15,15V335a15.017,15.017,0,0,0,15,15h156a15.017,15.017,0,0,0,15-15V208a15.017,15.017,0,0,0-15-15Z",
    transform: "translate(-231.30512 -178)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "eb40ba0f-f2ca-41e6-ba2e-bd824fb45cdc-190",
    "data-name": "Path 411",
    d: "M708.96338,229.138H630.23221a2.73088,2.73088,0,0,1-2.77562-2.48906,2.63064,2.63064,0,0,1,2.62678-2.77193h80.14349c2.64021,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "ea390b26-798a-41d7-8695-eb41cfeb13d4-191",
    "data-name": "Path 412",
    d: "M708.96338,242.948H630.23221a2.73088,2.73088,0,0,1-2.77562-2.48906,2.63064,2.63064,0,0,1,2.62678-2.77193h80.14349c2.64021,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "f9b4f79e-9356-48bc-89d8-91f80de67df3-192",
    "data-name": "Path 413",
    d: "M613.21237,250.811h-24.028a2.962,2.962,0,0,1-2.959-2.959V219.497a2.962,2.962,0,0,1,2.959-2.959h24.028a2.963,2.963,0,0,1,2.959,2.959v28.355a2.962,2.962,0,0,1-2.959,2.959Z",
    transform: "translate(-231.30512 -178)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "f3294a48-db04-45e1-afc8-dab6eb28e529-193",
    "data-name": "Path 414",
    d: "M708.73437,271.224H588.57619a2.73087,2.73087,0,0,1-2.7756-2.489,2.63061,2.63061,0,0,1,2.62677-2.77194H709.99883c2.64022,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "bb6dba8b-bb0a-4f92-a6ea-c6252f741607-194",
    "data-name": "Path 415",
    d: "M708.73437,285.038H588.57619a2.73087,2.73087,0,0,1-2.7756-2.48905,2.63061,2.63061,0,0,1,2.62677-2.77194H709.99883c2.64022,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "b1d451cb-91ad-40cf-876e-6a74c98e5c4f-195",
    "data-name": "Path 416",
    d: "M708.73437,298.843H588.57619a2.73086,2.73086,0,0,1-2.7756-2.48905,2.63061,2.63061,0,0,1,2.62677-2.77194H709.99883c2.64022,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "bcef27e7-bcca-4cc4-a6d4-200e9e04132c-196",
    "data-name": "Path 417",
    d: "M708.73437,312.656H588.57619a2.73086,2.73086,0,0,1-2.7756-2.489,2.63061,2.63061,0,0,1,2.62677-2.77194H709.99883c2.64022,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "ed29f808-f3a3-4ac8-bd45-563f73aa9d8b-197",
    "data-name": "Path 418",
    d: "M708.73437,326.462H588.57619a2.73087,2.73087,0,0,1-2.7756-2.48905,2.63062,2.63062,0,0,1,2.62677-2.77195H709.99883c2.64022,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M692.69488,178a5.00573,5.00573,0,0,1,5,5v16a5.00573,5.00573,0,0,1-5,5h-88a5.00573,5.00573,0,0,1-5-5V183a5.00573,5.00573,0,0,1,5-5",
    transform: "translate(-231.30512 -178)",
    fill: "#102b3f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M951.69488,509h-156a17.01917,17.01917,0,0,1-17-17V365a17.01917,17.01917,0,0,1,17-17h156a17.01917,17.01917,0,0,1,17,17V492A17.01917,17.01917,0,0,1,951.69488,509Zm-156-159a15.017,15.017,0,0,0-15,15V492a15.017,15.017,0,0,0,15,15h156a15.017,15.017,0,0,0,15-15V365a15.017,15.017,0,0,0-15-15Z",
    transform: "translate(-231.30512 -178)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "ab56b95a-ad0a-4db6-b885-1de339e59248-198",
    "data-name": "Path 411",
    d: "M933.96338,386.138H855.23221a2.73088,2.73088,0,0,1-2.77562-2.48906,2.63064,2.63064,0,0,1,2.62678-2.77193h80.14349c2.64021,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "a65ba0e0-92d5-467b-b937-6962ba88422c-199",
    "data-name": "Path 412",
    d: "M933.96338,399.948H855.23221a2.73088,2.73088,0,0,1-2.77562-2.48906,2.63064,2.63064,0,0,1,2.62678-2.77193h80.14349c2.64021,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#3f3d56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "fb801fe4-3edc-4e65-9957-dec023933e0a-200",
    "data-name": "Path 413",
    d: "M838.21237,407.811h-24.028a2.962,2.962,0,0,1-2.959-2.959V376.497a2.962,2.962,0,0,1,2.959-2.959h24.028a2.963,2.963,0,0,1,2.959,2.959v28.355a2.962,2.962,0,0,1-2.959,2.959Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "faab0864-6611-44c5-86ab-6dd51d336b1d-201",
    "data-name": "Path 413",
    d: "M933.21237,484.811h-24.028a2.962,2.962,0,0,1-2.959-2.959V465.497a2.962,2.962,0,0,1,2.959-2.959h24.028a2.963,2.963,0,0,1,2.959,2.959v16.355a2.962,2.962,0,0,1-2.959,2.959Z",
    transform: "translate(-231.30512 -178)",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "ada3facf-2b93-40cb-83c6-b6d8dc380c35-202",
    "data-name": "Path 414",
    d: "M933.73437,428.224H813.57619a2.73087,2.73087,0,0,1-2.7756-2.489,2.63061,2.63061,0,0,1,2.62677-2.77194H934.99883c2.64022,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "a50891a7-c495-4965-ab40-a1f907e5cce2-203",
    "data-name": "Path 415",
    d: "M933.73437,442.038H813.57619a2.73087,2.73087,0,0,1-2.7756-2.48905,2.63061,2.63061,0,0,1,2.62677-2.77194H934.99883c2.64022,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "f645be9d-0c31-4d92-bfb2-feede413f090-204",
    "data-name": "Path 416",
    d: "M933.73437,455.843H813.57619a2.73086,2.73086,0,0,1-2.7756-2.48905,2.63061,2.63061,0,0,1,2.62677-2.77194H934.99883c2.64022,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "f96ba49d-c571-4857-91da-e214cd5ba82f-205",
    "data-name": "Path 417",
    d: "M870.73437,469.656H813.57619a2.73086,2.73086,0,0,1-2.7756-2.489,2.63061,2.63061,0,0,1,2.62677-2.77194h58.57147c2.64022,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "a7214c6f-9d52-425a-b9ef-635698aec079-206",
    "data-name": "Path 418",
    d: "M870.73437,483.462H813.57619a2.73087,2.73087,0,0,1-2.7756-2.48905,2.63062,2.63062,0,0,1,2.62677-2.77195h58.57147c2.64022,2.32,1.03128,5.261-1.26446,5.261Z",
    transform: "translate(-231.30512 -178)",
    fill: "#ccc"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M917.69488,361h-88a5.00573,5.00573,0,0,1-5-5V340a5.00573,5.00573,0,0,1,5-5h88a5.00573,5.00573,0,0,1,5,5v16A5.00573,5.00573,0,0,1,917.69488,361Z",
    transform: "translate(-231.30512 -178)",
    fill: "#102b3f"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M613.30512,722h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-231.30512 -178)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.76378,
    cy: 23.3243,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.76378,
    cy: 49.0976,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.76378,
    cy: 74.8709,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.76378,
    cy: 100.6442,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.76378,
    cy: 23.3243,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.76378,
    cy: 49.0976,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.76378,
    cy: 74.8709,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.76378,
    cy: 100.6442,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.76378,
    cy: 23.3243,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.76378,
    cy: 49.0976,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.76378,
    cy: 74.8709,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.76378,
    cy: 100.6442,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.76378,
    cy: 23.3243,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.76378,
    cy: 49.0976,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.76378,
    cy: 74.8709,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 177.76378,
    cy: 100.6442,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.76378,
    cy: 23.3243,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.76378,
    cy: 49.0976,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.76378,
    cy: 74.8709,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.76378,
    cy: 100.6442,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.76378,
    cy: 23.3243,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.76378,
    cy: 49.0976,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.76378,
    cy: 74.8709,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.76378,
    cy: 100.6442,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.76378,
    cy: 381.3243,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.76378,
    cy: 407.0976,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 601.76378,
    cy: 432.8709,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.76378,
    cy: 381.3243,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.76378,
    cy: 407.0976,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 628.76378,
    cy: 432.8709,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.76378,
    cy: 381.3243,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.76378,
    cy: 407.0976,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 655.76378,
    cy: 432.8709,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 682.76378,
    cy: 381.3243,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 682.76378,
    cy: 407.0976,
    r: 6.46689,
    fill: "#f2f2f2"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 682.76378,
    cy: 432.8709,
    r: 6.46689,
    fill: "#f2f2f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesHero);
export default __webpack_public_path__ + "static/media/notes-hero.e3bbb1c40366b95e0f5ff1f3264aeb7e.svg";
export { ForwardRef as ReactComponent };